import type { RoadDTO, StationDTO } from "@/common/api";
import { pluralize } from "@/common/lib";

export const getWagonCount = (n: number | null | undefined): string => {
  if (n === null || n === undefined || n === 0) {
    return "0 вагонов";
  }

  return pluralize(n, "вагон", "вагона", "вагонов") || "0 вагонов";
};

export const getStationName = (road: RoadDTO | undefined, station: StationDTO | undefined) => {
  if (station) {
    return `${station.name} (${road?.name ?? station.fullRoad?.name})`;
  }

  if (road) {
    return road.fullName;
  }

  return null;
};
